import { render, staticRenderFns } from "./TabellaTempi.vue?vue&type=template&id=6ba8d980&"
import script from "./TabellaTempi.vue?vue&type=script&lang=js&"
export * from "./TabellaTempi.vue?vue&type=script&lang=js&"
import style0 from "./TabellaTempi.vue?vue&type=style&index=0&id=6ba8d980&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports